import { Input, Directive } from '@angular/core';
import {
	StatisticClientEditDto
} from 'app/services';

@Directive()
export abstract class ClientEditBaseComponent {
	@Input() client: StatisticClientEditDto;
}